import { render, staticRenderFns } from "./HandleArticleCategory.vue?vue&type=template&id=d7404726"
import script from "./HandleArticleCategory.vue?vue&type=script&lang=js"
export * from "./HandleArticleCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports